import type { ReactNode } from 'react';
import { useState } from 'react';

export interface ToggleDrawerProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const ToggleDrawer = ({ children }: { children: (_: ToggleDrawerProps) => ReactNode }) => {
  const [open, setOpen] = useState(false);
  return children({ open, setOpen });
};
